import * as types from "../actions/actionsTypes";
import initialState from "./initialState";

export default function checklistsReducer(state = initialState.checklistsData, action) {
  switch (action.type) {
    case types.LOAD_CHECKLISTS_DATA_SUCCESS:
      return action.checklistsData;
    default:
      return state;
  }
}
